angular.module('homebot.directives')

  .directive('sectionError', [function(){
    return {
      restrict: 'E',
      controllerAs: 'errorCtrl',
      bindToController: {
        content: '@'
      },
      templateUrl: '/homes/templates/partials/section-error.html',
      controller: function(){ },
      scope: {},
      link: function(){ }
    }

  }]);
